"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cases = {
    // svg attrs
    allowreorder: 'allowReorder',
    attributename: 'attributeName',
    attributetype: 'attributeType',
    autoreverse: 'autoReverse',
    basefrequency: 'baseFrequency',
    baseprofile: 'baseProfile',
    calcmode: 'calcMode',
    clippathunits: 'clipPathUnits',
    contentscripttype: 'contentScriptType',
    contentstyletype: 'contentStyleType',
    edgemode: 'edgeMode',
    externalresourcesrequired: 'externalResourcesRequired',
    filterres: 'filterRes',
    filterunits: 'filterUnits',
    glyphref: 'glyphRef',
    gradienttransform: 'gradientTransform',
    gradientunits: 'gradientUnits',
    kernelmatrix: 'kernelMatrix',
    kernelunitlength: 'kernelUnitLength',
    keypoints: 'keyPoints',
    keysplines: 'keySplines',
    keytimes: 'keyTimes',
    lengthadjust: 'lengthAdjust',
    limitingconeangle: 'limitingConeAngle',
    markerheight: 'markerHeight',
    markerunits: 'markerUnits',
    markerwidth: 'markerWidth',
    maskcontentunits: 'maskContentUnits',
    maskunits: 'maskUnits',
    numoctaves: 'numOctaves',
    pathlength: 'pathLength',
    patterncontentunits: 'patternContentUnits',
    patterntransform: 'patternTransform',
    patternunits: 'patternUnits',
    pointsatx: 'pointsAtX',
    pointsaty: 'pointsAtY',
    pointsatz: 'pointsAtZ',
    preservealpha: 'preserveAlpha',
    preserveaspectratio: 'preserveAspectRatio',
    primitiveunits: 'primitiveUnits',
    referrerpolicy: 'referrerPolicy',
    refx: 'refX',
    refy: 'refY',
    repeatcount: 'repeatCount',
    repeatdur: 'repeatDur',
    requiredextensions: 'requiredExtensions',
    requiredfeatures: 'requiredFeatures',
    specularconstant: 'specularConstant',
    specularexponent: 'specularExponent',
    spreadmethod: 'spreadMethod',
    startoffset: 'startOffset',
    stddeviation: 'stdDeviation',
    stitchtiles: 'stitchTiles',
    surfacescale: 'surfaceScale',
    systemlanguage: 'systemLanguage',
    tablevalues: 'tableValues',
    targetx: 'targetX',
    targety: 'targetY',
    textlength: 'textLength',
    viewbox: 'viewBox',
    viewtarget: 'viewTarget',
    xchannelselector: 'xChannelSelector',
    ychannelselector: 'yChannelSelector',
    zoomandpan: 'zoomAndPan',
    // xml attrs with semicolons
    xlinkactuate: 'xlink:actuate',
    xlinkarcrole: 'xlink:arcrole',
    xlinkhref: 'xlink:href',
    xlinkrole: 'xlink:role',
    xlinkshow: 'xlink:show',
    xlinktitle: 'xlink:title',
    xlinktype: 'xlink:type',
    xmlbase: 'xml:base',
    xmllang: 'xml:lang',
    xmlspace: 'xml:space',
    // all lowercase html attrs
    classname: 'class',
    htmlfor: 'for',
    accesskey: 'accesskey',
    contenteditable: 'contenteditable',
    contextmenu: 'contextmenu',
    spellcheck: 'spellcheck',
    tabindex: 'tabindex',
    autocapitalize: 'autocapitalize',
    autocorrect: 'autocorrect',
    autosave: 'autosave',
    itemprop: 'itemprop',
    itemscope: 'itemscope',
    itemtype: 'itemtype',
    itemid: 'itemid',
    itemref: 'itemref',
};
function specialCases(lcName) {
    return cases[lcName];
}
exports.specialCases = specialCases;
